import { DELETE_CMS_MENU_ACTION_TYPE, DELETE_CMS_STATIC_FILES_ACTION_TYPE, GET_CMS_CONTENT_ACTION_TYPE, IU_CMS_BANNER_ACTION_TYPE, IU_CMS_CONTENT_ACTION_TYPE, IU_CMS_CONTENT_SECTION_ACTION_TYPE, IU_CMS_FOOTER_ACTION_TYPE, IU_CMS_MENU_ACTION_TYPE, IU_CMS_STATIC_UPLOADS_ACTION_TYPE, IU_CMS_SUBHEADER_ACTION_TYPE, PUBLISH_CMS_BANNER_ACTION_TYPE, PUBLISH_CMS_CONTENT_ACTION_TYPE, PUBLISH_CMS_FOOTER_ACTION_TYPE, PUBLISH_CMS_MENU_ACTION_TYPE, PUBLISH_CMS_SUBHEADER_ACTION_TYPE, UPDATE_CMS_CONTENT_STATUS_ACTION_TYPE } from "../../utils/constants";

const initialState = [];
function cmsReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_CMS_CONTENT_ACTION_TYPE:
      return [...state, payload];
    case IU_CMS_CONTENT_ACTION_TYPE:
      return [...state, payload];
    case IU_CMS_CONTENT_SECTION_ACTION_TYPE:
      return [...state, payload];
    case IU_CMS_MENU_ACTION_TYPE:
      return [...state, payload];
    case IU_CMS_FOOTER_ACTION_TYPE:
      return [...state, payload];
    case IU_CMS_BANNER_ACTION_TYPE:
      return [...state, payload];
    case IU_CMS_SUBHEADER_ACTION_TYPE:
      return [...state, payload];
    case PUBLISH_CMS_MENU_ACTION_TYPE:
      return [...state, payload];
    case PUBLISH_CMS_CONTENT_ACTION_TYPE:
      return [...state, payload];
    case PUBLISH_CMS_FOOTER_ACTION_TYPE:
      return [...state, payload];
    case PUBLISH_CMS_BANNER_ACTION_TYPE:
      return [...state, payload];
    case PUBLISH_CMS_SUBHEADER_ACTION_TYPE:
      return [...state, payload];
    case UPDATE_CMS_CONTENT_STATUS_ACTION_TYPE:
      return [...state, payload];
    case DELETE_CMS_MENU_ACTION_TYPE:
      return [...state, payload];
    case IU_CMS_STATIC_UPLOADS_ACTION_TYPE:
      return [...state, payload];
    case DELETE_CMS_STATIC_FILES_ACTION_TYPE:
      return [...state, payload];
    default:
      return state;
  }
}
export default cmsReducer;
